// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__ubR3Z","title":"style_title__R2+1M","fadeIn":"style_fadeIn__iKe4E"};